import React, { useState, useEffect, useRef } from "react";
import TabNavigation from "./TabNavigation";
import TabContent from "./TabContent";

const SidingOptions = ({ sidingItem, availableOptions }) => {
  const [formData, setFormData] = useState(sidingItem || {});
  const [activeTab, setActiveTab] = useState("job_photos");
  const fileInputRef = useRef(null);

  const tabs = ["job_photos"];

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Update file input when job_photos changes
  useEffect(() => {
    if (
      fileInputRef.current &&
      formData.job_photos &&
      formData.job_photos.length > 0
    ) {
      const dataTransfer = new DataTransfer();
      formData.job_photos.forEach((file) => {
        if (file instanceof File) {
          dataTransfer.items.add(file);
        }
      });
      fileInputRef.current.files = dataTransfer.files;
    }
  }, [formData.job_photos]);

  return (
    <div className="space-y-4" data-testid="siding-options">
      <div className="p-2 bg-lighter rounded">
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        <TabContent
          activeTab={activeTab}
          formData={formData}
          onChange={handleChange}
        />
      </div>

      {/* File input for job photos */}
      <input
        ref={fileInputRef}
        type="file"
        name="sales_siding_item[job_photos][]"
        multiple
        style={{ display: "none" }}
      />

      {/* Hidden inputs for photos to remove */}
      {formData.job_photos_to_remove &&
        formData.job_photos_to_remove.map((photoId, index) => (
          <input
            key={`photo-to-remove-${index}`}
            type="hidden"
            name="sales_siding_item[job_photos_to_remove][]"
            value={photoId}
          />
        ))}
    </div>
  );
};

export default SidingOptions;
